module.exports = __webpack_public_path__ + "static/img/role.1c2cd8c.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/role3/lxx/role.png
// module id = jULg
// module chunks = 7